import { Navigate } from 'react-router-dom';

const ProtectedTherapistRoute = ({ children }) => {
  const userString = localStorage.getItem('user');
  
  if (!userString) {
    // Not logged in, redirect to login
    return <Navigate to="/login" />;
  }
  
  const user = JSON.parse(userString);
  
  if (user.role !== 'therapist') {
    // Not a therapist, redirect to home
    return <Navigate to="/" />;
  }
  
  // User is a therapist, render children
  return children;
};

export default ProtectedTherapistRoute;